const PLACES: { [key: string]: string } = {
    NEW_YORK: '85977539',
    MIAMI: '85933669',
};

// Add QA event ids for testing ,this will get repalce with production event IDs
export const FEATURE_EVENTS_MAPPING: { [key: string]: any } = {
    [PLACES.NEW_YORK]: [
        '91998759767',
        '92031166697',
        '38651646114',
        '38563990935',
        '8507914401',
        '44231810536',
    ],
    [PLACES.MIAMI]: [
        '42156113069',
        '53915332210',
        '53956459222',
        '54005565099',
        '53967844275',
        '53967799140',
    ],
};
